import {
    createSelector
} from 'reselect';


export const refreshSelector = createSelector(state => state.global && state.global.refresh, refreshSelector => refreshSelector )
